import { MUIIcon } from "../../../../../widgets"
import clsx from "clsx"

export enum DeviceType {
    Desktop = 'desktop',
    Tablet = 'tablet',
    Mobile = 'mobile',
};

const DeviceIconButton = ({ groupName, type, value, iconName, onChange }: {
    groupName: string,
    type: DeviceType,
    value: DeviceType,
    iconName: string,
    onChange: (type: DeviceType) => void
}) => {
    return <>
        <input
            type="radio"
            className="btn-check"
            name={groupName}
            id={`${groupName}-${type}`}
            autoComplete="off"
            onChange={() => onChange(type)}
            checked={value === type} />
        <label className="btn btn-sm btn-outlined p-0" htmlFor={`${groupName}-${type}`}>
            <MUIIcon iconName={iconName}
                className={clsx("fs-7", {
                    "text-light": value === type,
                    "text-gray-500": value !== type,
                })} />
        </label>
    </>
}

export const ToggleDeviceButtonGroup = ({ type, groupName, onChange }: {
    groupName: string,
    type: DeviceType,
    onChange: (type: DeviceType) => void
}) => {
    return <div className='d-flex gap-2 bg-dark text-light'>
        <DeviceIconButton groupName={groupName} iconName='DesktopWindowsOutlined' type={DeviceType.Desktop} value={type} onChange={onChange} />
        <DeviceIconButton groupName={groupName} iconName='TabletAndroidOutlined' type={DeviceType.Tablet} value={type} onChange={onChange} />
        <DeviceIconButton groupName={groupName} iconName='SmartphoneOutlined' type={DeviceType.Mobile} value={type} onChange={onChange} />
    </div>
}
